import { For, Icon, onMount } from 'cdui-js';
import { getAllInfos, getApplySaveExtra, nextProcess, pState } from './store';
import { saveApply } from '../../../../api/open-account';
import { createSubmitLock } from './createSubmitLock';
import i18n from '../../../../i18n';
import { replaceTemplate } from '@china-difi/lib/template';
import { OPEN_ACCOUNT_TRANSFER, formatTransferAmount } from '../../utils/open-account-transfer';
import { notifyOpenProgressReady } from './notifyOpenProgressReady';

const getList = () => [
  {
    icon: () => (
      // <div >
      <svg
        class="color-D"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        stroke="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.01876 9.00001C8.91664 7.67573 9.22266 6.35194 9.89564 5.20684C10.5686 4.06174 11.5762 3.15029 12.7829 2.59517C13.9895 2.04006 15.3373 1.86792 16.6447 2.10193C17.9522 2.33594 19.1565 2.96487 20.0957 3.90406C21.0349 4.84324 21.6638 6.04761 21.8978 7.35505C22.1318 8.66249 21.9597 10.0102 21.4046 11.2169C20.8495 12.4235 19.938 13.4312 18.7929 14.1041C17.6478 14.7771 16.324 15.0831 14.9998 14.981"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 17C22 17.7956 21.6839 18.5587 21.1213 19.1213C20.5587 19.6839 19.7956 20 19 20H17M17 20L19 18M17 20L19 22M2 7C2 6.20435 2.31607 5.44129 2.87868 4.87868C3.44129 4.31607 4.20435 4 5 4H7M7 4L5 6M7 4L5 2M8.5 22C6.77609 22 5.12279 21.3152 3.90381 20.0962C2.68482 18.8772 2 17.2239 2 15.5C2 13.7761 2.68482 12.1228 3.90381 10.9038C5.12279 9.68482 6.77609 9 8.5 9C10.2239 9 11.8772 9.68482 13.0962 10.9038C14.3152 12.1228 15 13.7761 15 15.5C15 17.2239 14.3152 18.8772 13.0962 20.0962C11.8772 21.3152 10.2239 22 8.5 22Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      // </div>
    ),
    title: i18n.OpenProgress.CheckMethod.OnlineTransfer,
    desc: replaceTemplate(i18n.OpenProgress.CheckMethod.OnlineTransferDesc, {
      amount: formatTransferAmount(OPEN_ACCOUNT_TRANSFER.minHkd),
    }),
    type: 'ONLINE_TRANSFER',
  },
  // 预约开户暂不开放
  // {
  //   icon: () => (
  //     <svg
  //       class="color-D"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       stroke="none"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M13 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V10M3 10H21M3 10V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H7M21 10V13M21 10V6C21 5.46957 20.7893 4.96086 20.4142 4.58579C20.0391 4.21071 19.5304 4 19 4H18.5M15 4V2M15 4V6M15 4H10.5M7 2V6M15.992 19H18.992M18.992 19H22M18.992 19V16M18.992 19V22"
  //         stroke="currentColor"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  //   title: i18n.OpenProgress.CheckMethod.Reservation,
  //   desc: i18n.OpenProgress.CheckMethod.ReservationDesc,
  //   type: 'RESERVATION',
  // },
];

export const CheckMethod = () => {
  const list = getList();
  const { lock, run } = createSubmitLock();

  onMount(() => {
    notifyOpenProgressReady(0);
  });

  const handleSelect = (type: string) => {
    if (pState.loading || lock.submitting) return;
    // 线上/预约已同包，无需预取
    if (type === 'RESERVATION') {
      /* offline already in open-flow chunk */
    }

    void run(async () => {
      // ── 新流程 backReopen：复用原单 id，保留已填资料，不开新单 ──
      if (pState.backReopenMode && pState.id) {
        await saveApply({
          id: pState.id,
          applyMethod: type,
          applyType: 'NEW_APPLY',
          ...getApplySaveExtra(),
        });
        pState.applyMethod = type;
        await getAllInfos();
        nextProcess();
        return;
      }

      // 开户方式：applyMethod（ONLINE_TRANSFER / RESERVATION）
      // 开户类型：applyType：NEW_APPLY 新开户 / ADD_ACCOUNT 新增账户
      const data = await saveApply({ applyMethod: type, applyType: 'NEW_APPLY', ...getApplySaveExtra() });
      pState.id = data.id;
      pState.applyMethod = type;
      getAllInfos().then(() => {});
      nextProcess();
    });
  };

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="color-D font-s-L font-bold" style={{ 'margin-bottom': '32px' }}>
        {i18n.OpenProgress.CheckMethod.Title}
      </div>

      <div>
        <For each={list}>
          {(item, index) => (
            <div
              class={`btn-option-item flex justify-space-between align-center margin-b-XXL${
                lock.submitting || pState.loading ? ' open-progress-interact-disabled' : ''
              }`}
              style={{ gap: '12px' }}
              onclick={() => handleSelect(item.type)}
            >
              <div class="flex align-center" style={{ flex: 1, 'min-width': 0, gap: '12px' }}>
                <div style={{ flex: '0 0 auto' }}>
                  <item.icon />
                </div>

                <div class="open-progress-step-content">
                  <div class="color-D font-s margin-b-XXS flex align-center" style={{ 'flex-wrap': 'wrap', gap: '4px' }}>
                    <span class="font-bold">{item.title}</span>

                    {index() === 0 && (
                      <div
                        class="font-s-XXS round-XS"
                        style={{ color: '#FF295A', background: '#FFEDED', padding: '2px 4px' }}
                      >
                        {i18n.OpenProgress.Common.Recommend}
                      </div>
                    )}
                  </div>
                  <div class="font-s-S open-progress-step-desc">{item.desc}</div>
                </div>
              </div>

              <Icon name="common-arrow-right" class="icon-c-D" style={{ flex: '0 0 auto' }}></Icon>
            </div>
          )}
        </For>
      </div>
    </div>
  );
};
